import cardone from "../Images/cardone";
import Message from "../Images/Message";
import Restore from "../Images/Restore";
const faqData = [
  {
    question: "What services does your software development company offer?",
    answer:
      "We offer a comprehensive range of services, including custom software development, mobile app development, web development, and software consulting.",
  },
  {
    question: "How experienced is your development team?",
    answer:
      "Our development team consists of highly skilled and experienced professionals with expertise in diverse technologies and industries.",
  },

  {
    question: "Can you work with specific technologies or frameworks?",
    answer:
      "Yes, we are proficient in a wide array of technologies and frameworks. Our team is adaptable and can work with the technologies that best suit your project requirements.",
  },
  {
    question: "What industries do you specialize in?",
    answer:
      "We have experience working across various industries, including healthcare, finance, e-commerce, education, and more.",
  },
  {
    question: "How do you ensure the security of our project",
    answer:
      "Security is a top priority for us. We implement industry best practices, conduct regular security audits, and adhere to stringent data protection measures.",
  },

  {
    question: "What is the typical development process followed by your company?",
    answer:
      "Our development process involves detailed project analysis, design, development, testing, deployment, and ongoing support. We follow agile methodologies for flexibility and client involvement.",
  },
  {
    question: "Can you handle both small projects and large-scale enterprise solutions?",
    answer:
      "Absolutely. We cater to projects of all sizes, ensuring that our solutions align with the specific needs and goals of our clients.",
  },
  {
    question: "How do you handle project management and communication?",
    answer:
      "We employ robust project management tools and maintain transparent communication channels to keep clients informed about project progress.",
  },
  {
    question: "What is the average timeline for completing a software project?",
    answer:
      "Project timelines vary depending on the complexity and scope. We provide detailed project timelines during the initial consultation.",
  },
  {
    question: "How do you handle changes or updates during the development process?",
    answer:
      "We welcome feedback and changes throughout the development process. We follow an iterative approach, ensuring flexibility to accommodate client requirements.",
  },

  {
    question: "Do you offer ongoing maintenance and support after the project is completed?",
    answer:
      "Yes, we provide ongoing maintenance and support to ensure the smooth functioning of your software and promptly address any issues that may arise.",
  },
  {
    question: "Can you assist with integrating the new software with existing systems?",
    answer:
      "Absolutely. We have expertise in seamless integration to ensure that the new software complements and enhances your existing systems.",
  },
  {
    question: "How do you ensure the quality of the software?",
    answer:
      "Quality assurance is integral to our development process. We conduct thorough testing at each stage to identify and resolve any issues promptly.",
  },

  {
    question: "What happens if we encounter issues after the project is completed?",
    answer:
      "We offer post-launch support to address any issues that may arise. Our team is committed to ensuring the long-term success of your software.",
  },
  {
    question: "Can you provide references or case studies of your previous projects?",
    answer:
      "Certainly. We can provide references and case studies upon request to showcase our successful collaborations.",
  },
  {
    question: "How do you handle intellectual property and confidentiality?",
    answer:
      "We prioritize client confidentiality and adhere to strict intellectual property protection measures. We are open to signing non-disclosure agreements (NDAs) as needed.",
  },

  {
    question: "What is your pricing model?",
    answer:
      "Our pricing model is tailored to the specific requirements of each project. We provide transparent and detailed cost estimates during the initial consultation.",
  },
  {
    question: "How do you handle changes in project scope or requirements?",
    answer:
      "We understand that project scopes may evolve. We work closely with clients to accommodate changes and adjust timelines and costs accordingly.",
  },
  {
    question: "What is your approach to user experience (UX) design?",
    answer:
      "We prioritize user-centric design, ensuring that our solutions provide an intuitive and enjoyable experience for end-users.",
  },
  {
    question: "How can we get started with a project?",
    answer:
      "Simply reach out to us through our website or contact us directly. We'll schedule an initial consultation to discuss your project goals, requirements, and next steps.",
  },
];

export default faqData;

export const work = [
  {
    class: "card-same-content",
    title: "Teamwork Thrives in the Office",
    desc: "Great software isn’t built in isolation, it’s forged through real-time collaboration, daily standups, and shared whiteboards. Our Stockholm office is a powerhouse of creativity, where designers and developers work side-by-side to eliminate bottlenecks, accelerate sprints, and ship flawless code. Remote work has its perks, but for cutting-edge digital craftsmanship, nothing beats the energy of a team firing on all cylinders.",
    icon: cardone,
  },
  {
    class: "card-same-dif-content",
    title: "Pixel-Perfect Code Meets Pixel-Perfect Design",
    desc: "UI/UX designers and full-stack developers don’t just coexist—they operate in lockstep. Through agile workflows, real-time syncs, and shared ownership, we ensure every button, API, and user flow is meticulously crafted. The result? Seamless digital experiences, faster iteration cycles, and products that look as stunning as they perform. No silos. No misaligned visions. Just end-to-end excellence.",
    icon: Restore,
  },
  {
    class: "card-same-content",
    title: "Software as a Service: Power Without the Overhead",
    desc: "Why drown in hiring chaos when you can tap into our tech arsenal on demand? Owision’s SaaS gives you premium development and design exactly when you need it. Build MVPs, scale fintech backends, or automate Shopify stores without the million dollar price tag. Pay as you go, zero friction, just relentless execution. Your roadmap, our problem solving. Let's turn “what if” into “what's next.”",
    icon: Message,
  },
];
